import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Navbar/Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState('Home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const currentPath = location.pathname.slice(1) || 'Home';
    setActiveLink(currentPath.charAt(0).toUpperCase() + currentPath.slice(1));
    setIsMobileMenuOpen(false); // Close mobile menu when route changes
  }, [location]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  return (
    <>
      <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="logo-box">
          <Link to="/">
            <img src="/shree.png" alt="Logo" className="logo-img" />
          </Link>
        </div>

        <div className="nav-center">
          <ul className="nav-links">
            <li className={activeLink === 'Home' ? 'active' : ''}>
              <Link to="/" className="link-text" onClick={() => setActiveLink('Home')}>
                Home
              </Link>
              <span className="link-underline"></span>
            </li>
            <li className={activeLink === 'About' ? 'active' : ''}>
              <Link to="/aboutus" className="link-text" onClick={() => setActiveLink('About')}>
                About Us
              </Link>
              <span className="link-underline"></span>
            </li>
            <li className={activeLink === 'Services' ? 'active' : ''}>
              <Link to="/services" className="link-text" onClick={() => setActiveLink('Services')}>
                Our Services
              </Link>
              <span className="link-underline"></span>
            </li>
            <li className={activeLink === 'Team' ? 'active' : ''}>
              <Link to="/work" className="link-text" onClick={() => setActiveLink('Team')}>
                Our Work
              </Link>
              <span className="link-underline"></span>
            </li>
            <li className={activeLink === 'Contact' ? 'active' : ''}>
              <Link to="/contact" className="link-text" onClick={() => setActiveLink('Contact')}>
                Contact Us
              </Link>
              <span className="link-underline"></span>
            </li>
          </ul>
        </div>

        <div className="contact-buttonn">
          <a href="tel:+919220347091">
            <i className="fas fa-phone-alt"></i>
            <span>+91 922-034-7091</span>
          </a>
        </div>

        {/* Hamburger Menu Button - Mobile Only */}
        <div className="hamburger-menu" onClick={toggleMobileMenu}>
          <div className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></div>
        </div>
      </div>

      {/* Mobile Menu - Slides down from top */}
      <div className={`mobile-menu-container ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-menu-links">
          <li className={activeLink === 'Home' ? 'active' : ''}>
            <Link to="/" className="link-text" onClick={() => setActiveLink('Home')}>
              Home
            </Link>
          </li>
          <li className={activeLink === 'About' ? 'active' : ''}>
            <Link to="/aboutus" className="link-text" onClick={() => setActiveLink('About')}>
              About Us
            </Link>
          </li>
          <li className={activeLink === 'Services' ? 'active' : ''}>
            <Link to="/services" className="link-text" onClick={() => setActiveLink('Services')}>
              Our Services
            </Link>
          </li>
          <li className={activeLink === 'Team' ? 'active' : ''}>
            <Link to="/work" className="link-text" onClick={() => setActiveLink('Team')}>
              Our Work
            </Link>
          </li>
          <li className={activeLink === 'Contact' ? 'active' : ''}>
            <Link to="/contact" className="link-text" onClick={() => setActiveLink('Contact')}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;